import axios from 'axios';

export default {
  /**
   * @async
   * @param {string} url - Must follow the form https://sketchfab.com/models/*
   * @returns {object} info
   * @returns {string} info.url
   * @returns {string} info.title
   * @returns {string} info.html
   * @returns {string} info.authorName
   * @returns {string} info.authorUrl
   * @returns {string} info.providerName
   * @returns {string} info.providerUrl
   * @returns {number} info.width
   * @returns {number} info.height
   * @returns {string} info.thumbnailUrl
   * @returns {number} info.thumbnailWidth
   * @returns {number} info.thumbnailHeight
   * @returns {number} info.version
   * @throws {Error}
   */
  getInfo(url) {
    if (!url.match(/https:\/\/sketchfab\.com\/models\/.+$/)) {
      return Promise.reject(new Error('Invalid sketchfab url:', url));
    }
    var options = {
      method: 'GET',
      baseURL: 'https://sketchfab.com',
      url: '/oembed',
      params: {
        url: url
      }
    };
    return axios.request(options).then(function(response) {
      // It appears that this service doesn't escape quotes in their JSON
      // responses, meaning that if the URL has quotes in it, it causes the body
      // parser to fail.
      if (typeof response.data === 'string') {
        throw new Error('Invalid response from sketchfab.com');
      }
      return {
        url:             response.data.url,
        title:           response.data.title,
        html:            response.data.html,
        authorName:      response.data.author_name,
        authorUrl:       response.data.author_url,
        providerName:    response.data.provider_name,
        providerUrl:     response.data.provider_url,
        width:           response.data.width,
        height:          response.data.height,
        thumbnailUrl:    response.data.thumbnail_url,
        thumbnailWidth:  response.data.thumbnail_width,
        thumbnailHeight: response.data.thumbnail_height,
        version:         response.data.version,
      };
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/sketchfab/index.js